module.exports = __webpack_public_path__ + "static/detail.1bda8b5a.png";